/*
  Il punteggio del rito. Funzioni pure, senza DOM: le usa rito.js nel
  browser e prova-rito.js in Node. La cascata dei pari: massimo; senza la
  specchio; le ancore nell'ordine in cui la sezione le passa (dal 5 ottobre
  2026 [ultima, 0]: decide la terza, poi la prima); la prima domanda
  risposta; l'ultima; altrimenti il doppio onesto, con le prime due nature
  in ordine di blocco.
*/
(function (radice, fabbrica) {
  if (typeof module === 'object' && module.exports) module.exports = fabbrica();
  else radice.RitoPunteggio = fabbrica();
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function chiavi(risposte) {
    var viste = [];
    for (var i = 0; i < risposte.length; i++) {
      if (risposte[i] != null && viste.indexOf(risposte[i]) < 0) viste.push(risposte[i]);
    }
    return viste;
  }

  /* Totali per natura. Con soloPeso si contano solo le domande di quel peso. */
  function punteggio(risposte, pesi, soloPeso) {
    var totali = {};
    for (var i = 0; i < risposte.length; i++) {
      var n = risposte[i];
      var p = pesi && pesi[i] != null ? pesi[i] : 2;
      if (n == null || (soloPeso != null && p !== soloPeso)) continue;
      totali[n] = (totali[n] || 0) + p;
    }
    return totali;
  }

  function inTesta(totali, nature) {
    var max = -1, pari = [];
    for (var i = 0; i < nature.length; i++) {
      var v = totali[nature[i]] || 0;
      if (v > max) { max = v; pari = [nature[i]]; } else if (v === max) pari.push(nature[i]);
    }
    return { max: max, pari: pari };
  }

  function vincitore(risposte, pesi, opzioni) {
    opzioni = opzioni || {};
    pesi = pesi || [];
    var nature = opzioni.nature || chiavi(risposte);
    var ancore = opzioni.ancore || [0, risposte.length - 1];
    var soglia = opzioni.soglia_forte == null ? 4 : opzioni.soglia_forte;
    var testa = inTesta(punteggio(risposte, pesi), nature);
    var pari = testa.pari, forte = testa.max >= soglia, i, n;
    function esito(natura, come) { return { natura: natura, forte: forte, tie_break: come, pari: pari }; }
    if (pari.length === 1) return esito(pari[0], 'none');
    var pieno = 0;
    for (i = 0; i < pesi.length; i++) if (pesi[i] > pieno) pieno = pesi[i];
    var senza = inTesta(punteggio(risposte, pesi, pieno), pari);
    if (senza.pari.length === 1) return esito(senza.pari[0], 'no_mirror');
    for (i = 0; i < ancore.length; i++) {
      n = risposte[ancore[i]];
      if (n != null && pari.indexOf(n) > -1) return esito(n, 'q' + (ancore[i] + 1));
    }
    for (i = 0; i < risposte.length; i++) {
      if (risposte[i] == null) continue;
      if (pari.indexOf(risposte[i]) > -1) return esito(risposte[i], 'prima');
      break;
    }
    for (i = risposte.length - 1; i >= 0; i--) {
      if (risposte[i] == null) continue;
      if (pari.indexOf(risposte[i]) > -1) return esito(risposte[i], 'ultima');
      break;
    }
    return { doppia: [pari[0], pari[1]], forte: forte, tie_break: 'dual', pari: pari };
  }

  return { punteggio: punteggio, vincitore: vincitore };
});
